import { useState } from "react";
import SelectField from '../../common/SelectField.js';
import { useModal } from "../../../context/ModalContext";
import { useTranslation } from 'react-i18next';


export default function JoinPlatformModal() {
  const { isJoinOpen, closeJoinModal } = useModal();

  const [registerForm, setRegisterForm] = useState({
    name: "",
    email: "",
    phone: "",
    product: "",
    password: "",
    confirmPassword: "",
  });

  if (!isJoinOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

      {/* MODAL */}
      <div className="bg-white max-w-2xl w-full mx-4 rounded-xl shadow-2xl animate-[fadeIn_0.25s_ease]">

        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-t-xl">
          <h3 className="text-lg font-semibold text-white">
            Join DigiQin Platform - Request Access
          </h3>

          <button
            onClick={closeJoinModal}
            className="text-white text-xl hover:opacity-80"
          >
            ✕
          </button>
        </div>

        {/* INFO SECTION */}
        <div className="px-6 pt-6">
          <div className="text-center space-y-3">

            <h4 className="text-sm font-semibold text-gray-700">
              Why join DigiQin?
            </h4>

            <p className="text-gray-500 text-sm max-w-md mx-auto px-4 py-2 border-t border-b border-purple-100 bg-gradient-to-r from-white via-purple-50 to-white">
              One platform to manage Logistics & Inventory Management.
            </p>

            <div className="flex justify-center gap-6 pt-2 text-sm text-gray-600">
              <span className="flex items-center gap-1">
                <span className="text-purple-600">✓</span> Secure onboarding
              </span>
              <span className="flex items-center gap-1">
                <span className="text-purple-600">✓</span> Shipment to Settlement
              </span>
              <span className="flex items-center gap-1">
                <span className="text-purple-600">✓</span> Free trial available
              </span>
            </div>

          </div>
        </div>

        {/* FORM */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">

            <input
              type="text"
              placeholder="Company name"
              value={registerForm.name}
              onChange={(e) =>
                setRegisterForm({ ...registerForm, name: e.target.value })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 focus:ring-2 focus:ring-purple-500 outline-none"
            />

            <input
              type="email"
              placeholder="Enter email address"
              value={registerForm.email}
              onChange={(e) =>
                setRegisterForm({ ...registerForm, email: e.target.value })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 focus:ring-2 focus:ring-purple-500 outline-none"
            />

            <input
              type="tel"
              placeholder="Enter phone number"
              value={registerForm.phone}
              onChange={(e) =>
                setRegisterForm({ ...registerForm, phone: e.target.value })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 focus:ring-2 focus:ring-purple-500 outline-none"
            />

            <SelectField variant="form"
              value={registerForm.product}
              onChange={(e) =>
                setRegisterForm({ ...registerForm, product: e.target.value })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 bg-white focus:ring-2 focus:ring-purple-500 outline-none"
            >
              <option value="">Select Product</option>
              <option value="dq-logix">DQ-Logix (Logistics Platform)</option>
              <option value="dq-ims">DQ-IMS (Inventory Management)</option>
              <option value="dq-web">DQ – Website & Digital Marketing</option>
            </SelectField>

            <input
              type="password"
              placeholder="Create password"
              value={registerForm.password}
              onChange={(e) =>
                setRegisterForm({ ...registerForm, password: e.target.value })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 focus:ring-2 focus:ring-purple-500 outline-none"
            />

            <input
              type="password"
              placeholder="Re-enter password"
              value={registerForm.confirmPassword}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  confirmPassword: e.target.value,
                })
              }
              className="w-full px-4 py-2.5 rounded-md border border-gray-300 focus:ring-2 focus:ring-purple-500 outline-none"
            />
          </div>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3 rounded-b-xl">
          <button
            onClick={closeJoinModal}
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-600 text-sm hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            className="px-6 py-2 rounded-md bg-purple-900 text-white text-sm font-semibold hover:shadow-lg transition"
          >
            Register
          </button>
        </div>

        <p className="pt-4 pb-6 text-xs text-gray-500 text-center">
          Already have an account?
          <span className="ml-1 text-purple-700 font-medium cursor-pointer hover:underline">
            Sign in
          </span>
        </p>

      </div>
    </div>
  );
}
